
import { NewCropCyclePeriodFilter } from 'src/app/core/models/period-selector/newCropCyclePeriodFilter';
import { NewPeriodSelectorInterval } from 'src/app/core/enums/newPeriodSelectorInterval';
import { NewCropCyclePeriodSelectorItem } from './base/new-crop-cycle-period-selector-item';


export class FullPeriodSelectorItem extends NewCropCyclePeriodSelectorItem {
    interval = NewPeriodSelectorInterval.Full;
    hasNavigation = false;

    constructor(name: string) {
        super(name);
    }

    getPeriodFilter = () => {
        const periodFilter = new NewCropCyclePeriodFilter();
        periodFilter.periodInterval = NewPeriodSelectorInterval.Full;
        return periodFilter;
    }
}